define.alias("shared/components/shared/plan-recommendation/steps/goal", "preview-grid/components/shared/plan-recommendation/steps/goal");